/* ============================================================
   TGC Gear — NivoDrive homepage interactions
   Vanilla JS, no dependencies. Every handler is scoped to a
   .tgc section, so nothing here can affect Horizon's own
   components. Cart submission stays Horizon's job: this file
   only writes the selected variant id into the theme's own
   product form.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Smooth scroll with sticky-header offset ---------- */
  function headerOffset() {
    /* This theme's header sticks to the top of the page and overlays whatever
       is under it, so a jump has to clear it or it lands with its first 90px
       hidden. Measuring the header group is no good - a transparent header is
       taken out of flow and its group measures 0 - so the number comes from
       --header-height, which assets/header.js keeps up to date on the body. */
    var v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    if (!isFinite(v) || v <= 0) {
      var h = document.querySelector('.header, header.header, #header-group, .shopify-section-group-header-group');
      v = h ? h.getBoundingClientRect().height : 0;
    }
    return v + 12;
  }

  /* An in-page link names one target in its href. A link pointing at something
     the theme does not own - a reviews app's container - can list fallbacks in
     data-tgc-jump, and the first candidate actually on the page wins, so the
     link does not go dead the day the app renames its widget. */
  function jumpTarget(a) {
    var list = [];
    var href = a.getAttribute('href') || '';
    if (href.length > 1 && href.charAt(0) === '#') list.push(href);
    var extra = a.getAttribute('data-tgc-jump');
    if (extra) list = list.concat(extra.split(','));
    for (var i = 0; i < list.length; i++) {
      var sel = list[i].trim();
      if (!sel) continue;
      var el = null;
      try { el = document.querySelector(sel); } catch (err) { el = null; }
      if (el) return el;
    }
    return null;
  }

  /* scrollIntoView rather than window.scrollTo: from 990px up, base.css freezes
     the document and hands the scrolling to .page-wrapper, so scrolling the
     window there moves nothing at all. scrollIntoView finds whichever box is
     doing the scrolling on its own, and the sticky header is cleared with
     scroll-margin, which the browser reads as it works out where to land.
     The margin belongs to the target, which may be an app's element, so it is
     put back once the scroll is over. */
  function jumpTo(target) {
    var offset = headerOffset();
    var was = target.style.scrollMarginTop;
    var events = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    var stopped = false;

    function done() {
      events.forEach(function (n) { window.removeEventListener(n, stop, true); });
      target.style.scrollMarginTop = was;
    }
    function stop() { stopped = true; done(); }
    events.forEach(function (n) { window.addEventListener(n, stop, { capture: true, passive: true }); });

    function land(smooth) {
      target.style.scrollMarginTop = offset + 'px';
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'instant', block: 'start' });
    }
    land(!reduce);

    /* A jump that only moves the page leaves the keyboard where it was, so the
       next Tab carries on from the link and walks back down through everything
       already passed. Moving focus to the landing makes the rest of the journey
       follow from it. tabindex -1 keeps it out of the tab order itself, and
       preventScroll stops the browser doing a second, unanimated jump of its
       own on top of the one in flight. */
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try {
      target.focus({ preventScroll: true });
    } catch (err) {
      /* Older Safari throws on the options object; the scroll has still landed. */
    }

    /* Six thousand pixels of lazily-loaded images is six thousand pixels of
       layout still settling: on this product page the reviews move nearly 600px
       while the scroll is in flight, and a scroll that aimed at where they used
       to be lands well past them. So the landing is checked once the animation
       is over and corrected without one - and abandoned the moment the reader
       scrolls for themselves, since nothing is worse than being pulled back. */
    var tries = 0;
    function check() {
      if (stopped) return;
      if (Math.abs(target.getBoundingClientRect().top - offset) > 4) land(false);
      if (++tries < 4) setTimeout(check, 400);
      else done();
    }
    setTimeout(check, 700);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.tgc a[href^="#"], a[data-tgc-jump]') : null;
    if (!a) return;
    var target = jumpTarget(a);
    if (!target) return;
    e.preventDefault();
    jumpTo(target);
  });

  /* ---------- Disclosures + FAQ accordion ---------- */
  function wireDisclosures(root) {
    $$('[data-tgc-disclosure]', root).forEach(function (btn) {
      if (btn.dataset.tgcBound) return;
      btn.dataset.tgcBound = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.dataset.open = String(!open);
      });
    });
    var faqBtns = $$('.faq__btn', root);
    faqBtns.forEach(function (b, i) {
      if (b.dataset.tgcKeys) return;
      b.dataset.tgcKeys = '1';
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown') n = faqBtns[(i + 1) % faqBtns.length];
        if (e.key === 'ArrowUp')   n = faqBtns[(i - 1 + faqBtns.length) % faqBtns.length];
        if (e.key === 'Home')      n = faqBtns[0];
        if (e.key === 'End')       n = faqBtns[faqBtns.length - 1];
        if (n) { e.preventDefault(); n.focus(); }
      });
    });
  }




  /* ---------- Demo video placeholder ---------- */
  function wireVideo(root) {
    $$('[data-tgc-play]', root).forEach(function (btn) {
      if (btn.dataset.tgcBound) return;
      btn.dataset.tgcBound = '1';
      btn.addEventListener('click', function () {
        var holder = btn.closest('[data-tgc-video-host]');
        var tpl = holder && holder.querySelector('template');
        if (tpl) {
          holder.innerHTML = tpl.innerHTML;
          var media = holder.querySelector('video, iframe');
          if (media && media.tagName === 'VIDEO') media.play();
        }
      });
    });

    /* A looping tile video (snippets/tgc-cl-media.liquid) is decorative
       motion. Someone whose system asks for less of it gets the first frame,
       held still, rather than a silent loop they cannot stop. */
    if (reduce) {
      $$('video[data-tgc-loop]', root).forEach(function (v) {
        if (v.dataset.tgcLoopBound) return;
        v.dataset.tgcLoopBound = '1';
        v.removeAttribute('autoplay');
        v.autoplay = false;
        v.pause();
      });
    }

    /* The loop tiles carry preload="none" and no autoplay, so nothing of the
       video crosses the network until play() is called. This calls it when the
       tile arrives and pauses it again when it leaves: a visitor who never
       scrolls that far pays nothing for three demo videos, and one who does
       sees the same silent loop as before.

       The 200px margin starts the fetch just before the tile is actually
       visible, so the loop is usually running by the time it is looked at. A
       reduced-motion visitor never reaches here and keeps the still poster. */
    if (!reduce && 'IntersectionObserver' in window) {
      var lazyVideos = $$('video[data-tgc-lazy]', root).filter(function (v) {
        return !v.dataset.tgcLazyBound;
      });
      if (lazyVideos.length) {
        var vio = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              var v = en.target;
              if (en.isIntersecting) {
                if (v.preload === 'none') v.preload = 'auto';
                var played = v.play();
                if (played && played.catch) played.catch(function () {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.1 }
        );
        lazyVideos.forEach(function (v) {
          v.dataset.tgcLazyBound = '1';
          vio.observe(v);
        });
      }
    }
  }

  /* ---------- Scroll reveal ---------- */
  function wireReveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var targets = $$('[data-tgc-reveal]', root).filter(function (t) { return !t.dataset.tgcBound; });
    targets.forEach(function (t) { t.dataset.tgcBound = '1'; t.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    targets.forEach(function (t) {
      if (t.getBoundingClientRect().top < window.innerHeight * 0.98) t.classList.add('is-in');
      else io.observe(t);
    });
  }

  /* A scroll-snapping row, plus the arrows, dots and counter that describe it.

     The scroller is the source of truth throughout: the buttons ask it to
     scroll and everything else is read back off scrollLeft, so a finger swipe,
     a trackpad flick and a button press all end up telling the same story. */
  /* A marquee is a CSS animation over two copies of the cards; all that is
     wanted here is its duration.

     The setting is a speed in pixels a second rather than a duration, because a
     duration would mean a phone showing one and a half cards and a desktop
     showing three and a half ran the same distance in the same time — two
     visibly different speeds from one number. Distance is only knowable once the
     row is laid out, so it is measured, and measured again when the layout
     changes underneath it. */
  function wireMarquees(root) {
    var stages = root.querySelectorAll('[data-tgc-marquee]');
    Array.prototype.forEach.call(stages, function (stage) {
      if (stage.dataset.tgcMarqueeReady === 'true') return;
      stage.dataset.tgcMarqueeReady = 'true';

      var track = stage.querySelector('[data-tgc-slider-track]');
      if (!track) return;

      function time() {
        var speed = Number(stage.dataset.tgcMarqueeSpeed) || 40;
        var cards = track.children;
        if (cards.length < 2) return;

        // One copy's pitch: the distance from a card to the same card in the
        // second copy, which is exactly what the keyframe travels.
        var travel = track.scrollWidth / 2;
        if (cards.length > 1) {
          var pitch = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
          travel = (cards.length / 2) * pitch;
        }
        if (!(travel > 0)) return;
        track.style.setProperty('--tgc-rs-marquee-dur', travel / speed + 's');
      }

      time();

      // Cards carry pictures, and a picture that arrives late changes the width
      // the duration was worked out from.
      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(time);
        ro.observe(track);
      } else {
        window.addEventListener('resize', time);
      }
    });
  }

  function wireSliders(root) {
    var stages = root.querySelectorAll('[data-tgc-slider]');
    Array.prototype.forEach.call(stages, function (stage) {
      if (stage.dataset.tgcSliderReady === 'true') return;
      stage.dataset.tgcSliderReady = 'true';

      var track = stage.querySelector('[data-tgc-slider-track]');
      if (!track) return;
      var cards = track.children;
      if (!cards.length) return;

      /* Endless forward travel, opt-in. The section renders its cards twice and
         says how many are real; past the end of the first copy the scroller is
         silently pulled back by exactly one copy, which lands on a card with
         the same words in the same place - so the row only ever moves forward
         and never rewinds in front of the reader. Zero, and everything below
         behaves as it always has: a row with two ends. */
      var loop = Number(stage.dataset.tgcLoop) || 0;

      var prev = stage.querySelector('[data-tgc-slider-prev]');
      var next = stage.querySelector('[data-tgc-slider-next]');
      var scope = stage.parentNode || stage;
      var dots = scope.querySelectorAll('[data-tgc-slider-dot]');
      var count = scope.querySelector('[data-tgc-slider-count]');

      function step() {
        var a = cards[0].getBoundingClientRect();
        if (cards.length < 2) return a.width;
        // Measured rather than read off the gap setting, so a changed gap or a
        // fractional card width needs no second source of truth.
        return cards[1].getBoundingClientRect().left - a.left;
      }

      function span() { return track.scrollWidth - track.clientWidth; }

      /* One dot per card, and the lit one is the card at the left edge — the
         thing the reader is actually looking at.

         Reading it off the travelled distance instead was tried and is worse:
         with four and a half cards showing out of five there is half a card of
         travel, so the third dot would jump the row to its end and the counter
         would read 5 of 5 while cards two, three and four had never moved. How
         far a row can travel is a fact about the layout, not about which card
         is in view, and the two must not be confused. */
      function current() {
        var s = step();
        return s > 0 ? Math.round(track.scrollLeft / s) : 0;
      }

      /* Clamped, because the last cards share the final resting place: a row
         showing four of five has one card of travel, so dots two through five
         all mean "the end". */
      function offsetFor(i) { return Math.min(i * step(), span()); }

      // How many cards the reader is meant to believe in.
      var real = loop > 0 ? loop : cards.length;

      function copyWidth() { return real * step(); }

      /* Instant, and it has to be said out loud: the page sets scroll-behavior
         smooth globally, so assigning scrollLeft would animate the pull-back
         and the reader would watch the row rewind - the exact thing this is
         here to avoid. The inline value is put back afterwards so nothing else
         inherits it. */
      function jump(left) {
        var was = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        track.style.scrollBehavior = was || '';
      }

      /* Only ever by a whole copy, so the resting position stays a snap point
         and the card under the reader's eye does not change. */
      function rewind() {
        if (!loop) return;
        var copy = copyWidth();
        if (copy <= 0) return;
        if (track.scrollLeft >= copy - 1) jump(track.scrollLeft - copy);
      }

      function atStart() { return track.scrollLeft <= 1; }
      function atEnd() {
        return track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }

      function paint() {
        var i = Math.min(current(), cards.length - 1);

        /* The bright card is the one actually under the reader, duplicate or
           not; the dots and the counter speak in real cards, so the second copy
           reads as "1 of 6" again rather than "7 of 12". */
        var r = real > 0 ? i % real : i;

        Array.prototype.forEach.call(dots, function (dot, k) {
          dot.setAttribute('aria-selected', k === r ? 'true' : 'false');
        });
        if (count) count.textContent = (r + 1) + ' / ' + real;

        /* Which card the row is resting on, published on the cards themselves.
           The dots already knew it; nothing but the dots could read it. A row
           that dims everything but the card in view needs the same fact in CSS,
           and working it out a second time in a second place is how the two
           drift apart. Rows that do not style it are unaffected: this writes an
           attribute no existing rule matches. */
        Array.prototype.forEach.call(cards, function (card, k) {
          card.setAttribute('data-tgc-current', k === i ? 'true' : 'false');
        });

        // A looping row has no ends to arrive at, so neither arrow ever dies
        // and neither edge stops fading.
        var head = loop ? false : atStart();
        var tail = loop ? false : atEnd();
        if (prev) prev.disabled = head;
        if (next) next.disabled = tail;

        /* The same two facts drive the soft edges: a side is only faded while
           there is something more to see past it. The CSS reads these, so a
           row that never scrolls never gets a fade it has no use for. */
        stage.dataset.tgcAtStart = head ? 'true' : 'false';
        stage.dataset.tgcAtEnd = tail ? 'true' : 'false';
      }

      /* The buttons still move by one card, which is what a click should feel
         like; the scroller clamps at its own ends. */
      function go(by) {
        /* Backwards off the front would hit a wall. Landing on the same card
           one copy along first gives the step somewhere to come from, and the
           reader sees one smooth move rather than a jump and a move. */
        if (loop && by < 0 && atStart()) {
          var copy = copyWidth();
          if (copy > 0) jump(copy);
        }
        track.scrollBy({ left: by * step(), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      Array.prototype.forEach.call(dots, function (dot, k) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: offsetFor(k), behavior: 'smooth' });
        });
      });

      var pending = false;
      var resting = null;
      track.addEventListener('scroll', function () {
        /* Waiting for the row to stop before pulling it back, rather than doing
           it the moment the line is crossed: moving the scroller mid-animation
           fights the animation, and a drag still under a thumb would be yanked
           out from under it. A tenth of a second of quiet is the row at rest. */
        if (loop) {
          if (resting) clearTimeout(resting);
          resting = setTimeout(function () { rewind(); paint(); }, 140);
        }
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; paint(); });
      });

      window.addEventListener('resize', paint);
      paint();

      /* Auto-advance. It steps the scroller exactly as the next arrow does, so
         there is one way a row moves and one place it can be wrong.

         It stops while the pointer is over the row or the focus is inside it —
         a row that moves out from under a reader is worse than one that never
         moved — and while the tab is hidden, where a timer would only pile up
         work nobody is watching. A reader who asks for reduced motion is not
         given any. */
      var delay = Number(stage.dataset.tgcAutoplay) * 1000;
      if (!(delay > 0)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var timer = null;
      var held = false;

      function tick() {
        if (held || document.hidden) return;
        // A looping row just keeps going; the pull-back above makes the end
        // somewhere it never arrives. Otherwise, back to the top rather than
        // stalling on the last card: a row that stops silently reads as broken.
        if (loop) go(1);
        else if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
        else go(1);
      }

      function start() {
        if (timer) return;
        timer = setInterval(tick, delay);
      }

      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      function hold(on) {
        held = on;
      }

      /* The dots sit outside the stage - under it, in their own row - so a
         pointer on its way to one was not holding anything, and the row could
         advance out from under the dot being aimed at. Both sliders put them
         there, so the second hold zone belongs here rather than in either. */
      var zones = [stage];
      if (dots.length && dots[0].parentNode) zones.push(dots[0].parentNode);

      zones.forEach(function (zone) {
        zone.addEventListener('pointerenter', function () { hold(true); });
        zone.addEventListener('pointerleave', function () { hold(false); });
        zone.addEventListener('focusin', function () { hold(true); });
        zone.addEventListener('focusout', function () { hold(false); });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      start();
    });
  }

  function init(root) {
    root = root || document;
    wireDisclosures(root);
    wireVideo(root);
    wireReveal(root);
    wireSliders(root);
    wireMarquees(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-initialise when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });

  /* ---------- Cart type: go somewhere after adding ----------

     Horizon reads settings.cart_type in exactly two places, and both only
     decide whether the drawer markup exists. The product form always posts to
     cart/add.js and never navigates, so with the drawer switched off an add
     produced no feedback beyond the header count quietly changing.

     layout/theme.liquid works out the destination — the cart for "Page",
     payment for "Checkout", nothing at all for "Drawer" — so this only has to
     follow it.

     The event is Shopify's own lines-update, whose promise resolves after the
     add has settled and carries didError, so a failed add stays put and shows
     the theme's error instead of navigating away from it. Quantity changes on
     the cart page carry a different action and are ignored.

     It is dispatched as 'shopify:cart:lines-update'. The name in
     @shopify/events reads 'cart:lines-update' and the namespace is added when
     it is fired, so the unprefixed name never matches anything; both are bound
     here in case a later version drops the prefix. */
  function onCartLines(event) {
    /* Never inside the theme editor. The preview is an iframe on the admin,
       and checkout is a URL it refuses to show: one test click on ADD TO
       CART there turned the whole editor into "Failed to load the page …
       redirecting to an unsupported URL". Shopify.designMode is the switch
       Shopify documents for exactly this. */
    if (window.Shopify && window.Shopify.designMode) return;

    var target = document.body.getAttribute('data-tgc-after-add');
    if (!target || event.action !== 'add') return;

    var go = function () { window.location.assign(target); };

    if (!event.promise) { go(); return; }
    event.promise.then(function (result) {
      if (result && result.detail && result.detail.didError) return;
      go();
    }).catch(function () { /* the theme reports the failure; stay put */ });
  }

  document.addEventListener('shopify:cart:lines-update', onCartLines);
  document.addEventListener('cart:lines-update', onCartLines);
})();
